import { createContext, useContext, type ReactNode } from "react";
import { FpjsProvider } from "@fingerprintjs/fingerprintjs-pro-react";
// eslint-disable-next-line import/no-extraneous-dependencies
import type { Endpoint } from "@fingerprintjs/fingerprintjs-pro";

type FingerprintConfiguration = {
  fingerprintApiKey: string;
  deviceMonitoringEnabled: boolean;
};

type OptionalFingerprintProviderProps = FingerprintConfiguration & {
  fingerprintEndpoint: Endpoint;
  fingerprintScriptSrc: string;
  children: ReactNode;
};

const FingerprintEnabledContext = createContext(false);

export const isFingerprintEnabled = ({
  fingerprintApiKey,
  deviceMonitoringEnabled,
}: FingerprintConfiguration): boolean =>
  Boolean(fingerprintApiKey) && deviceMonitoringEnabled;

export const useIsFingerprintEnabled = (): boolean =>
  useContext(FingerprintEnabledContext);

export const OptionalFingerprintProvider = ({
  fingerprintApiKey,
  fingerprintEndpoint,
  fingerprintScriptSrc,
  deviceMonitoringEnabled,
  children,
}: OptionalFingerprintProviderProps) => {
  const isEnabled = isFingerprintEnabled({
    fingerprintApiKey,
    deviceMonitoringEnabled,
  });

  return (
    <FingerprintEnabledContext.Provider value={isEnabled}>
      {isEnabled ? (
        <FpjsProvider
          loadOptions={{
            apiKey: fingerprintApiKey,
            endpoint: fingerprintEndpoint,
            scriptUrlPattern: fingerprintScriptSrc,
          }}
        >
          {children}
        </FpjsProvider>
      ) : (
        children
      )}
    </FingerprintEnabledContext.Provider>
  );
};
